import { AccountMyReferralBanner } from "@/containers/profile/account-my-referral/account-my-referral-banner";
import { View } from "@/components/ui";
import { VisitList } from "../visit-list";
import NoVisitsVaccum from "@/assets/images/3d-illus/no-visits-vaccum.png";
import { EmptyCard } from "@/components/shared/empty-card";
import { MapPinArea } from "@/components/shared/icons";
import { useVisitHistory } from "@/containers/visits/use-visit-history";

export const VisitsHistory = () => {
  const { isEmpty, historyQuery } = useVisitHistory();

  return (
    <View className="mb-6 flex flex-col gap-6 px-4 md:px-0">
      <View className="mt-4">
        <AccountMyReferralBanner />
      </View>
      {isEmpty ? (
        <EmptyCard
          src={NoVisitsVaccum}
          title="You don't have any history visits"
          desc="Your completed bookings will appear here once the service is done."
        />
      ) : (
        <VisitList query={historyQuery} title="Past Visits" icon={MapPinArea} />
      )}
    </View>
  );
};
